if (!customElements.get('rt-cart-recommendations')) {
  customElements.define('rt-cart-recommendations', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      fetch(this.dataset.url, { signal: this.controller.signal })
        .then(response => { if (!response.ok) throw new Error('Recommendations unavailable'); return response.text(); })
        .then(html => {
          const result = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-recommendations-result]');
          if (result && this.isConnected) this.replaceChildren(...result.childNodes);
        }).catch(() => {});
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
